window._ = require('lodash');
window.Popper = require('popper.js').default;

try {
    window.$ = window.jQuery = require('jquery');
    require('bootstrap');
} catch (e) {
}

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

require('fastclick');
require('jquery-easing');
window.$ = window.ScrollReveal = require('scrollreveal');
require('magnific-popup');
require('./creative');

window.Vue = require('vue');

Vue.component('rsvp', require('./components/RSVP.vue'));

const app = new Vue({
    el: '#rsvp'
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js